<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fXSpMh/tc-custom/9783987448966.jpg?1704424886654" alt="This image is the cover for the book My Disillusionment in Russia, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Disillusionment in Russia, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>My Disillusionment in Russia is a book by Emma Goldman, published in 1923 by Doubleday, Page &amp; Co. The book was based on a much longer manuscript entitled "My Two Years in Russia" which was an eyewitness account of events in Russia from 1920 to 1921 that ensued in the wake of the Russian Revolution of 1917 and which culminated in the Kronstadt rebellion. Long-concerned about developments with the Bolsheviks, Goldman described the rebellion as the "final wrench. I saw before me the Bolshevik State, formidable, crushing every constructive revolutionary effort, suppressing, debasing, and disintegrating everything".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Goldman
      </h2>
      
      <p class="authorDescription body article">Emma Goldman (June 27, 1869 – May 14, 1940) was an anarchist political activist and writer. She played a pivotal role in the development of anarchist political philosophy in North America and Europe in the first half of the 20th century.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23d0f397